var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1091 61.798L22.6871 88.5623L22.6859 88.572C22.5511 89.6503 22.9444 90.7915 23.8326 91.3913C24.3958 91.81 24.9704 91.953 25.5311 91.953C26.0936 91.953 26.5368 91.8093 26.9623 91.5304L50.7873 78.7462L74.8828 91.3178L74.9003 91.3253C75.8373 91.7269 76.9919 91.7582 77.8839 91.0149C78.7129 90.324 79.1392 89.3365 78.9996 88.2197L78.9979 88.2068L74.2265 61.4399L93.652 42.4797L93.6563 42.4754C94.5154 41.6163 94.6446 40.4763 94.3708 39.5179C94.0762 38.4869 93.1947 37.7737 92.0761 37.6326L92.0728 37.6322L65.2069 33.9105L52.9864 9.70225L52.98 9.69103C52.434 8.73561 51.5753 8.14709 50.4316 8.14709C49.3311 8.14709 48.3095 8.70181 47.8628 9.73073L36.0021 34.1497L9.13417 38.2206L9.13207 38.2209C8.12669 38.3655 7.15372 39.1936 6.85373 40.1923C6.41568 41.2549 6.88688 42.3904 7.55924 43.0627L27.1091 61.798ZM40.4254 37.8821L50.554 17.1747L60.7903 37.6472C61.2095 38.4857 61.9301 39.068 62.9286 39.2106L85.5397 42.3604L69.342 58.4457L69.3407 58.4469C68.6391 59.1486 68.3524 60.1332 68.4963 60.9969L72.5466 83.4986L52.1871 73.0376L52.1822 73.0351C51.3367 72.6124 50.3488 72.6124 49.5033 73.0351L49.4959 73.0388L29.3611 83.9499L33.072 61.348L33.0734 61.3377C33.2131 60.3597 32.9259 59.4977 32.2274 58.7992L15.6844 42.9315L38.287 39.4455L38.2898 39.4451C39.2868 39.3018 40.0065 38.7198 40.4254 37.8821Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStella);
export default __webpack_public_path__ + "static/media/stella.a0ac2eccf69914d03c727d073c8a0d34.svg";
export { ForwardRef as ReactComponent };